export const LANGUAGES = [
    { value: "Acholi", label: "Acholi" },
    { value: "Afrikaans", label: "Afrikaans" },
    { value: "Akan", label: "Akan" },
    { value: "Albanian", label: "Albanian" },
    { value: "Amharic", label: "Amharic" },
    { value: "Arabic", label: "Arabic" },
    { value: "Ashante", label: "Ashante" },
    { value: "Asl", label: "Asl" },
    { value: "Assyrian", label: "Assyrian" },
    { value: "Azerbaijani", label: "Azerbaijani" },
    { value: "Azeri", label: "Azeri" },
    { value: "Bajuni", label: "Bajuni" },
    { value: "Basque", label: "Basque" },
    { value: "Behdini", label: "Behdini" },
    { value: "Belorussian", label: "Belorussian" },
    { value: "Bengali", label: "Bengali" },
    { value: "Berber", label: "Berber" },
    { value: "Bosnian", label: "Bosnian" },
    { value: "Bravanese", label: "Bravanese" },
    { value: "Bulgarian", label: "Bulgarian" },
    { value: "Burmese", label: "Burmese" },
    { value: "Cakchiquel", label: "Cakchiquel" },
    { value: "Cambodian", label: "Cambodian" },
    { value: "Cantonese", label: "Cantonese" },
    { value: "Catalan", label: "Catalan" },
    { value: "Chaldean", label: "Chaldean" },
    { value: "Chamorro", label: "Chamorro" },
    { value: "Chaochow", label: "Chao-chow" },
    { value: "Chavacano", label: "Chavacano" },
    { value: "Chin", label: "Chin" },
    { value: "Chuukese", label: "Chuukese" },
    { value: "Cree", label: "Cree" },
    { value: "Croatian", label: "Croatian" },
    { value: "Czech", label: "Czech" },
    { value: "Dakota", label: "Dakota" },
    { value: "Danish", label: "Danish" },
    { value: "Dari", label: "Dari" },
    { value: "Dinka", label: "Dinka" },
    { value: "Diula", label: "Diula" },
    { value: "Dutch", label: "Dutch" },
    { value: "Edo", label: "Edo" },
    { value: "English", label: "English" },
    { value: "Estonian", label: "Estonian" },
    { value: "Ewe", label: "Ewe" },
    { value: "Fante", label: "Fante" },
    { value: "Farsi", label: "Farsi" },
    { value: "FijianHindi", label: "Fijian Hindi" },
    { value: "Finnish", label: "Finnish" },
    { value: "Flemish", label: "Flemish" },
    { value: "French", label: "French" },
    { value: "FrenchCanadian", label: "French Canadian" },
    { value: "Fukienese", label: "Fukienese" },
    { value: "Fula", label: "Fula" },
    { value: "Fulani", label: "Fulani" },
    { value: "Fuzhou", label: "Fuzhou" },
    { value: "Ga", label: "Ga" },
    { value: "Gaddang", label: "Gaddang" },
    { value: "Gaelic", label: "Gaelic" },
    { value: "Gaelicirish", label: "Gaelic-irish" },
    { value: "Gaelicscottish", label: "Gaelic-scottish" },
    { value: "Georgian", label: "Georgian" },
    { value: "German", label: "German" },
    { value: "Gorani", label: "Gorani" },
    { value: "Greek", label: "Greek" },
    { value: "Gujarati", label: "Gujarati" },
    { value: "HaitianCreole", label: "Haitian Creole" },
    { value: "Hakka", label: "Hakka" },
    { value: "Hakkachinese", label: "Hakka-chinese" },
    { value: "Hausa", label: "Hausa" },
    { value: "Hebrew", label: "Hebrew" },
    { value: "Hindi", label: "Hindi" },
    { value: "Hmong", label: "Hmong" },
    { value: "Hungarian", label: "Hungarian" },
    { value: "Ibanag", label: "Ibanag" },
    { value: "Ibo", label: "Ibo" },
    { value: "Icelandic", label: "Icelandic" },
    { value: "Igbo", label: "Igbo" },
    { value: "Ilocano", label: "Ilocano" },
    { value: "Indonesian", label: "Indonesian" },
    { value: "Inuktitut", label: "Inuktitut" },
    { value: "Italian", label: "Italian" },
    { value: "Jakartanese", label: "Jakartanese" },
    { value: "Japanese", label: "Japanese" },
    { value: "Javanese", label: "Javanese" },
    { value: "Kanjobal", label: "Kanjobal" },
    { value: "Karen", label: "Karen" },
    { value: "Karenni", label: "Karenni" },
    { value: "Kashmiri", label: "Kashmiri" },
    { value: "Kazakh", label: "Kazakh" },
    { value: "Kikuyu", label: "Kikuyu" },
    { value: "Kinyarwanda", label: "Kinyarwanda" },
    { value: "Kirundi", label: "Kirundi" },
    { value: "Korean", label: "Korean" },
    { value: "Kosovan", label: "Kosovan" },
    { value: "Kotokoli", label: "Kotokoli" },
    { value: "Krio", label: "Krio" },
    { value: "Kurdish", label: "Kurdish" },
    { value: "Kurmanji", label: "Kurmanji" },
    { value: "Kyrgyz", label: "Kyrgyz" },
    { value: "Lakota", label: "Lakota" },
    { value: "Laotian", label: "Laotian" },
    { value: "Latvian", label: "Latvian" },
    { value: "Lingala", label: "Lingala" },
    { value: "Lithuanian", label: "Lithuanian" },
    { value: "Luganda", label: "Luganda" },
    { value: "Luo", label: "Luo" },
    { value: "Maay", label: "Maay" },
    { value: "Macedonian", label: "Macedonian" },
    { value: "Malay", label: "Malay" },
    { value: "Malayalam", label: "Malayalam" },
    { value: "Maltese", label: "Maltese" },
    { value: "Mandarin", label: "Mandarin" },
    { value: "Mandingo", label: "Mandingo" },
    { value: "Mandinka", label: "Mandinka" },
    { value: "Marathi", label: "Marathi" },
    { value: "Marshallese", label: "Marshallese" },
    { value: "Mien", label: "Mien" },
    { value: "Mina", label: "Mina" },
    { value: "Mirpuri", label: "Mirpuri" },
    { value: "Mixteco", label: "Mixteco" },
    { value: "Moldavan", label: "Moldavan" },
    { value: "Mongolian", label: "Mongolian" },
    { value: "Montenegrin", label: "Montenegrin" },
    { value: "Navajo", label: "Navajo" },
    { value: "Neapolitan", label: "Neapolitan" },
    { value: "Nepali", label: "Nepali" },
    { value: "NigerianPidgin", label: "Nigerian Pidgin" },
    { value: "Norwegian", label: "Norwegian" },
    { value: "Oromo", label: "Oromo" },
    { value: "Pahari", label: "Pahari" },
    { value: "Papago", label: "Papago" },
    { value: "Papiamento", label: "Papiamento" },
    { value: "Pashto", label: "Pashto" },
    { value: "Patois", label: "Patois" },
    { value: "PidginEnglish", label: "Pidgin English" },
    { value: "Polish", label: "Polish" },
    { value: "Portugcreole", label: "Portug.creole" },
    { value: "Portuguese", label: "Portuguese" },
    { value: "Pothwari", label: "Pothwari" },
    { value: "Pulaar", label: "Pulaar" },
    { value: "Punjabi", label: "Punjabi" },
    { value: "Putian", label: "Putian" },
    { value: "Quichua", label: "Quichua" },
    { value: "Romanian", label: "Romanian" },
    { value: "Russian", label: "Russian" },
    { value: "Samoan", label: "Samoan" },
    { value: "Serbian", label: "Serbian" },
    { value: "Shanghainese", label: "Shanghainese" },
    { value: "Shona", label: "Shona" },
    { value: "Sichuan", label: "Sichuan" },
    { value: "Sicilian", label: "Sicilian" },
    { value: "Sinhalese", label: "Sinhalese" },
    { value: "Slovak", label: "Slovak" },
    { value: "Somali", label: "Somali" },
    { value: "Sorani", label: "Sorani" },
    { value: "Spanish", label: "Spanish" },
    { value: "SudaneseArabic", label: "Sudanese Arabic" },
    { value: "Sundanese", label: "Sundanese" },
    { value: "Susu", label: "Susu" },
    { value: "Swahili", label: "Swahili" },
    { value: "Swedish", label: "Swedish" },
    { value: "Sylhetti", label: "Sylhetti" },
    { value: "Tagalog", label: "Tagalog" },
    { value: "Taiwanese", label: "Taiwanese" },
    { value: "Tajik", label: "Tajik" },
    { value: "Tamil", label: "Tamil" },
    { value: "Telugu", label: "Telugu" },
    { value: "Thai", label: "Thai" },
    { value: "Tibetan", label: "Tibetan" },
    { value: "Tigre", label: "Tigre" },
    { value: "Tigrinya", label: "Tigrinya" },
    { value: "Toishanese", label: "Toishanese" },
    { value: "Tongan", label: "Tongan" },
    { value: "Toucouleur", label: "Toucouleur" },
    { value: "Trique", label: "Trique" },
    { value: "Tshiluba", label: "Tshiluba" },
    { value: "Turkish", label: "Turkish" },
    { value: "Twi", label: "Twi" },
    { value: "Ukrainian", label: "Ukrainian" },
    { value: "Urdu", label: "Urdu" },
    { value: "Uyghur", label: "Uyghur" },
    { value: "Uzbek", label: "Uzbek" },
    { value: "Vietnamese", label: "Vietnamese" },
    { value: "Visayan", label: "Visayan" },
    { value: "Welsh", label: "Welsh" },
    { value: "Wolof", label: "Wolof" },
    { value: "Yiddish", label: "Yiddish" },
    { value: "Yoruba", label: "Yoruba" },
    { value: "Yupik", label: "Yupik" }
];
export const LANGUAGE_MAP = {
    "Acholi": { label: "Acholi" },
    "Afrikaans": { label: "Afrikaans" },
    "Akan": { label: "Akan" },
    "Albanian": { label: "Albanian" },
    "Amharic": { label: "Amharic" },
    "Arabic": { label: "Arabic" },
    "Ashante": { label: "Ashante" },
    "Asl": { label: "Asl" },
    "Assyrian": { label: "Assyrian" },
    "Azerbaijani": { label: "Azerbaijani" },
    "Azeri": { label: "Azeri" },
    "Bajuni": { label: "Bajuni" },
    "Basque": { label: "Basque" },
    "Behdini": { label: "Behdini" },
    "Belorussian": { label: "Belorussian" },
    "Bengali": { label: "Bengali" },
    "Berber": { label: "Berber" },
    "Bosnian": { label: "Bosnian" },
    "Bravanese": { label: "Bravanese" },
    "Bulgarian": { label: "Bulgarian" },
    "Burmese": { label: "Burmese" },
    "Cakchiquel": { label: "Cakchiquel" },
    "Cambodian": { label: "Cambodian" },
    "Cantonese": { label: "Cantonese" },
    "Catalan": { label: "Catalan" },
    "Chaldean": { label: "Chaldean" },
    "Chamorro": { label: "Chamorro" },
    "Chaochow": { label: "Chao-chow" },
    "Chavacano": { label: "Chavacano" },
    "Chin": { label: "Chin" },
    "Chuukese": { label: "Chuukese" },
    "Cree": { label: "Cree" },
    "Croatian": { label: "Croatian" },
    "Czech": { label: "Czech" },
    "Dakota": { label: "Dakota" },
    "Danish": { label: "Danish" },
    "Dari": { label: "Dari" },
    "Dinka": { label: "Dinka" },
    "Diula": { label: "Diula" },
    "Dutch": { label: "Dutch" },
    "Edo": { label: "Edo" },
    "English": { label: "English" },
    "Estonian": { label: "Estonian" },
    "Ewe": { label: "Ewe" },
    "Fante": { label: "Fante" },
    "Farsi": { label: "Farsi" },
    "FijianHindi": { label: "Fijian Hindi" },
    "Finnish": { label: "Finnish" },
    "Flemish": { label: "Flemish" },
    "French": { label: "French" },
    "FrenchCanadian": { label: "French Canadian" },
    "Fukienese": { label: "Fukienese" },
    "Fula": { label: "Fula" },
    "Fulani": { label: "Fulani" },
    "Fuzhou": { label: "Fuzhou" },
    "Ga": { label: "Ga" },
    "Gaddang": { label: "Gaddang" },
    "Gaelic": { label: "Gaelic" },
    "Gaelicirish": { label: "Gaelic-irish" },
    "Gaelicscottish": { label: "Gaelic-scottish" },
    "Georgian": { label: "Georgian" },
    "German": { label: "German" },
    "Gorani": { label: "Gorani" },
    "Greek": { label: "Greek" },
    "Gujarati": { label: "Gujarati" },
    "HaitianCreole": { label: "Haitian Creole" },
    "Hakka": { label: "Hakka" },
    "Hakkachinese": { label: "Hakka-chinese" },
    "Hausa": { label: "Hausa" },
    "Hebrew": { label: "Hebrew" },
    "Hindi": { label: "Hindi" },
    "Hmong": { label: "Hmong" },
    "Hungarian": { label: "Hungarian" },
    "Ibanag": { label: "Ibanag" },
    "Ibo": { label: "Ibo" },
    "Icelandic": { label: "Icelandic" },
    "Igbo": { label: "Igbo" },
    "Ilocano": { label: "Ilocano" },
    "Indonesian": { label: "Indonesian" },
    "Inuktitut": { label: "Inuktitut" },
    "Italian": { label: "Italian" },
    "Jakartanese": { label: "Jakartanese" },
    "Japanese": { label: "Japanese" },
    "Javanese": { label: "Javanese" },
    "Kanjobal": { label: "Kanjobal" },
    "Karen": { label: "Karen" },
    "Karenni": { label: "Karenni" },
    "Kashmiri": { label: "Kashmiri" },
    "Kazakh": { label: "Kazakh" },
    "Kikuyu": { label: "Kikuyu" },
    "Kinyarwanda": { label: "Kinyarwanda" },
    "Kirundi": { label: "Kirundi" },
    "Korean": { label: "Korean" },
    "Kosovan": { label: "Kosovan" },
    "Kotokoli": { label: "Kotokoli" },
    "Krio": { label: "Krio" },
    "Kurdish": { label: "Kurdish" },
    "Kurmanji": { label: "Kurmanji" },
    "Kyrgyz": { label: "Kyrgyz" },
    "Lakota": { label: "Lakota" },
    "Laotian": { label: "Laotian" },
    "Latvian": { label: "Latvian" },
    "Lingala": { label: "Lingala" },
    "Lithuanian": { label: "Lithuanian" },
    "Luganda": { label: "Luganda" },
    "Luo": { label: "Luo" },
    "Maay": { label: "Maay" },
    "Macedonian": { label: "Macedonian" },
    "Malay": { label: "Malay" },
    "Malayalam": { label: "Malayalam" },
    "Maltese": { label: "Maltese" },
    "Mandarin": { label: "Mandarin" },
    "Mandingo": { label: "Mandingo" },
    "Mandinka": { label: "Mandinka" },
    "Marathi": { label: "Marathi" },
    "Marshallese": { label: "Marshallese" },
    "Mien": { label: "Mien" },
    "Mina": { label: "Mina" },
    "Mirpuri": { label: "Mirpuri" },
    "Mixteco": { label: "Mixteco" },
    "Moldavan": { label: "Moldavan" },
    "Mongolian": { label: "Mongolian" },
    "Montenegrin": { label: "Montenegrin" },
    "Navajo": { label: "Navajo" },
    "Neapolitan": { label: "Neapolitan" },
    "Nepali": { label: "Nepali" },
    "NigerianPidgin": { label: "Nigerian Pidgin" },
    "Norwegian": { label: "Norwegian" },
    "Oromo": { label: "Oromo" },
    "Pahari": { label: "Pahari" },
    "Papago": { label: "Papago" },
    "Papiamento": { label: "Papiamento" },
    "Pashto": { label: "Pashto" },
    "Patois": { label: "Patois" },
    "PidginEnglish": { label: "Pidgin English" },
    "Polish": { label: "Polish" },
    "Portugcreole": { label: "Portug.creole" },
    "Portuguese": { label: "Portuguese" },
    "Pothwari": { label: "Pothwari" },
    "Pulaar": { label: "Pulaar" },
    "Punjabi": { label: "Punjabi" },
    "Putian": { label: "Putian" },
    "Quichua": { label: "Quichua" },
    "Romanian": { label: "Romanian" },
    "Russian": { label: "Russian" },
    "Samoan": { label: "Samoan" },
    "Serbian": { label: "Serbian" },
    "Shanghainese": { label: "Shanghainese" },
    "Shona": { label: "Shona" },
    "Sichuan": { label: "Sichuan" },
    "Sicilian": { label: "Sicilian" },
    "Sinhalese": { label: "Sinhalese" },
    "Slovak": { label: "Slovak" },
    "Somali": { label: "Somali" },
    "Sorani": { label: "Sorani" },
    "Spanish": { label: "Spanish" },
    "SudaneseArabic": { label: "Sudanese Arabic" },
    "Sundanese": { label: "Sundanese" },
    "Susu": { label: "Susu" },
    "Swahili": { label: "Swahili" },
    "Swedish": { label: "Swedish" },
    "Sylhetti": { label: "Sylhetti" },
    "Tagalog": { label: "Tagalog" },
    "Taiwanese": { label: "Taiwanese" },
    "Tajik": { label: "Tajik" },
    "Tamil": { label: "Tamil" },
    "Telugu": { label: "Telugu" },
    "Thai": { label: "Thai" },
    "Tibetan": { label: "Tibetan" },
    "Tigre": { label: "Tigre" },
    "Tigrinya": { label: "Tigrinya" },
    "Toishanese": { label: "Toishanese" },
    "Tongan": { label: "Tongan" },
    "Toucouleur": { label: "Toucouleur" },
    "Trique": { label: "Trique" },
    "Tshiluba": { label: "Tshiluba" },
    "Turkish": { label: "Turkish" },
    "Twi": { label: "Twi" },
    "Ukrainian": { label: "Ukrainian" },
    "Urdu": { label: "Urdu" },
    "Uyghur": { label: "Uyghur" },
    "Uzbek": { label: "Uzbek" },
    "Vietnamese": { label: "Vietnamese" },
    "Visayan": { label: "Visayan" },
    "Welsh": { label: "Welsh" },
    "Wolof": { label: "Wolof" },
    "Yiddish": { label: "Yiddish" },
    "Yoruba": { label: "Yoruba" },
    "Yupik": { label: "Yupik" }
};